export default "__VITE_ASSET__DnrCf4x9__"